import AssessmentIcon from '@mui/icons-material/Assessment';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import BalanceIcon from '@mui/icons-material/Balance';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import BookIcon from '@mui/icons-material/Book';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
/**
 * arrayIcons: Lista de reportes con su ícono de MUI, título y tooltip descriptivo
 *   - Usamos `sx` para personalizar tamaño (fontSize) y color gris claro (grey.500)
 */
export const arrayIcons = [
  {
    icon: <AssessmentIcon sx={{ fontSize: 64, color: 'grey.500' }} />,  // Estado De Resultados Por Periodo
    title: 'Estado De Resultados Por Periodo',
    id: '2',
    tooltip: 'Un estado de resultados del periodo es un informe financiero que presenta los ingresos, costos, gastos y la utilidad o pérdida obtenida por una empresa durante un periodo contable específico.',
  },
  {
    icon: <ShowChartIcon sx={{ fontSize: 64, color: 'grey.500' }} />,  // Estado De Resultados Comparativo
    title: 'Estado De Resultados Comparativo',
    id: '3',
    tooltip: 'Un estado de resultados comparativo es un informe financiero que muestra los ingresos, costos, gastos y utilidades de una empresa para dos o más periodos contables, colocándolos lado a lado para facilitar la comparación.',
  },
  {
    icon: <AccountBalanceWalletIcon sx={{ fontSize: 64, color: 'grey.500' }} />,  // Cobranza
    title: 'Reporte De Documentos Por Cobrar',
    id: '4',
    tooltip: 'Un reporte de documentos por cobrar es un informe que detalla todas las facturas, letras u otros documentos pendientes de pago que los clientes deben a la empresa.',
  },
  {
    icon: <BalanceIcon sx={{ fontSize: 64, color: 'grey.500' }} />,  // Balance General
    title: 'Balance General',
    id: '5',
    tooltip: 'El balance de 8 columnas muestra, en una sola tabla, tanto las cuentas de balance (activos, pasivos y patrimonio) como las cuentas de resultado (ingresos, costos y gastos), incluyendo saldos iniciales, ajustes y saldos finales para ver la situación y el desempeño de la empresa.',
  },
  {
    icon: <MonetizationOnIcon sx={{ fontSize: 64, color: 'grey.500' }} />,  // Deuda
    title: 'Reporte De Documentos Por Pagar',
    id: '6',
    tooltip: 'Un reporte de documentos por pagar es un informe que muestra todas las facturas, letras u otros compromisos pendientes que la empresa debe a sus proveedores u otros acreedores.',
  },
  {
    icon: <ReceiptLongIcon sx={{ fontSize: 64, color: 'grey.500' }} />,  // Libro Auxiliar de Cliente
    title: 'Libro Auxiliar de Cliente',
    id: '8',
    tooltip: 'El libro auxiliar de clientes es un registro contable detallado donde se anotan, cliente por cliente, todas las operaciones que generan saldos a favor de la empresa, como facturas emitidas, pagos recibidos, notas de crédito y otros movimientos, permitiendo conocer en todo momento cuánto debe cada cliente y el historial de sus transacciones.',
  },
  {
    icon: <ReceiptLongIcon sx={{ fontSize: 64, color: 'grey.500' }} />,  // Libro Auxiliar de Proveedores
    title: 'Libro Auxiliar de Proveedores',
    id: '9',
    tooltip: 'El libro auxiliar de proveedores es un registro contable detallado donde se anotan, proveedor por proveedor, todas las operaciones que generan deudas para la empresa, como facturas recibidas, pagos realizados, notas de crédito y otros movimientos, permitiendo conocer en todo momento cuánto se le debe a cada proveedor y el historial de esas transacciones.',
  },
  /*{
    icon: <AccountBalanceIcon sx={{ fontSize: 64, color: 'grey.500' }} />,  // Conciliaciones Bancarias
    title: 'Conciliaciones Bancarias',
    id: '10',
    tooltip: 'Verifica y ajusta las transacciones bancarias para coincidir con los registros contables.',
  },*/
  {
    icon: <MenuBookIcon sx={{ fontSize: 64, color: 'grey.500' }} />,  // Libro Diario
    title: 'Libro Diario',
    id: '11',
    tooltip: 'Es el registro contable donde se anotan, en orden cronológico, todas las operaciones de la empresa, indicando las cuentas afectadas, sus débitos y créditos, y una breve descripción de la transacción. Es el punto de partida de la contabilidad.',
  },
  {
    icon: <BookIcon sx={{ fontSize: 64, color: 'grey.500' }} />,  // Libro Mayor
    title: 'Libro Mayor',
    id: '12',
    tooltip: 'Es el registro que agrupa todas las operaciones del libro diario por cuenta contable. Permite ver, para cada cuenta, sus movimientos de débito y crédito, así como su saldo final, facilitando el control y análisis de la información financiera.',
  },
  {
    icon: <AccountBalanceIcon sx={{ fontSize: 64, color: 'grey.500' }} />,  // Libro Banco Conciliaciones
    title: 'Libro Banco',
    id: '13',
    tooltip: 'Movimientos bancarios con el detalle de facturas y comprobantes que fueron conciliados a cada pago/cobro.',
  },
];